import { HTTP_ALB } from '../axios';



//  直播间视角 添加排班列表
export const schedulingadd = (params) => {
  return HTTP_ALB.post('/scheduling/scheduling/add', params);
}

//  直播间视角 添加排班列表
export const schedulingedit = (params) => {
  return HTTP_ALB.post('/scheduling/scheduling/edit', params);
}

//  直播间视角 历史排班列表
export const schedulingeroomlisthis = (params) => {
  return HTTP_ALB.get('/scheduling/scheduling/room_list_his', params);
}

//  直播间视角 排班列表
export const schedulingroomlist = (params) => {
  return HTTP_ALB.get('/scheduling/scheduling/room_list', params);
}

//  直播间视角 排班列表人员
export const schedulingwrokuser = (params) => {
  return HTTP_ALB.get('/scheduling/scheduling/work_time', params);
}

//  直播间视角 主播列表
export const schedulinguselist = (params) => {
  return HTTP_ALB.get('/scheduling/scheduling/work_list', params);
}

export const schedulinguselist1 = (params) => {
  return HTTP_ALB.get('/anchor/week/plan', params);
}

// 获取实际场次打卡人员
export const scheduledgetstaff = (params) => {
  return HTTP_ALB.post('/scheduling/scheduling/get_staff', params)
}
